import _ from 'underscore';
import Backbone from 'backbone';
import Radio from 'backbone.radio';
import Counts from '@/models/v5/counts';

    var apiCh = Radio.channel('api');

    var collection = new Backbone.Collection();
    collection.model = Counts;

    var PRODUCT_DEVICES_DEFAULT = {
        development: 0,
        enroled: 0,
        factoryfixture: 0,
        production: 0
    };
    
    /**
     * Create a counts model for a given model. The model could
     * be *anything* we have a 'counts' endpoint for, and of current
     * writing that could be an Account, a Product, or a Devicegroup.
     *
     * Every counts model has the same id and type as its parent model.
     * This may sound confusing! and it kind of is. But this is because 
     * a 'counts' object is not really a JsonApi or EI Api v5 type of
     * thing, and we just need a way to get at it in this collection.
     *
     * So for these counts models, 
     *     - id     is the id of the parent, 
     *     - type   is the type of the parent
     *
     * If you wanted to, you could filter the collection for all 'counts'
     * pertaining to devicegroups. Or accounts, or whatever. 
     */
    collection.create_counts_model_for = function(parent_model, url_func, item_type) {
        var m = collection.get(parent_model.id);
        if (!m) {
            m = collection.add({ 
                id: parent_model.id, 
                type: parent_model.type 
            }, {
                type: parent_model.type,
                item_type: item_type
            });
        }
        m.url = function url() {
            return url_func({ id: parent_model.id });
        };
        m.on('change', function(counts_model) {
            var groups = apiCh.request('development_devicegroup');
            var inverted_map = _.invert(groups.TYPES_MAP);
            if ('devices' in counts_model.changed) {
                // If the count is for an individual devicegroup, 
                // we will have to propagate the changes to the 
                // counts objects for the product and account
                // the devicegroup belongs to.
                if (counts_model.get('type') in inverted_map) {
                    var group = groups.get(counts_model.id);
                    // It's possible we haven't fetch
                    if (!group) {
                        console.warn("no group fetched for %s", counts_model.id);
                        return;
                    }
                    if (!group.product) {
                        group.fetch();
                    } else {
                        var product_devices_count =  _.clone(group.product.counts.get('devices')
                                                     || PRODUCT_DEVICES_DEFAULT);
                        product_devices_count[inverted_map[counts_model.get('type')]] += counts_model.get('devices') - (counts_model.previous('devices') || 0);
                        group.product.counts.set('devices', product_devices_count);
                    }
                }
            }
        });
        return m;
    };
    export default collection;

